export default {"src":"/_next/static/media/medium_icon.a5e6b4d1.svg","height":88,"width":91,"blurWidth":0,"blurHeight":0};